import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

interface PlayerOverlayProps {
  url: string;
  title?: string;
  onClose: () => void;
}

const PlayerOverlay: React.FC<PlayerOverlayProps> = ({ url, title, onClose }) => {
  if (!url) return null;

  return (
    <div className="audio-overlay">
        <div className="audio-modal">
          <CloseIcon
            onClick={onClose}
            className="close-icon"
          />
          {title && <h4 className="audio-title">{title}</h4>}
          <AudioPlayer src={url} autoPlay />
        </div>
    </div>
  );
};

export default PlayerOverlay;